<template>
  <div :class="$style.fixFilter">
    <AtomsConsumerButton
      v-if="filterCountNum > 0"
      :class="[$style.filteredActive, $style.fixFilterInner]"
      @click="$emit('update:isOpenFilterSp', true)"
    >
      <p :class="[$style.filteredActiveText]">{{ displayActiveFilterColumn() }}</p>

      <div :class="$style.filteredActiveLink">
        <AtomsConsumerImage src="/images/icon/filter-icon.svg" alt="filter" :width="12" :height="12" />
        絞り込み
      </div>
    </AtomsConsumerButton>
    <AtomsConsumerButton
      v-else
      :class="[$style.defaultFilterOpenButton, $style.fixFilterInner]"
      @click="$emit('update:isOpenFilterSp', true)"
    >
      <AtomsConsumerImage src="/images/icon/filter-icon.svg" alt="filter" :width="12" :height="12" />
      絞り込み
    </AtomsConsumerButton>
  </div>
</template>

<script lang="ts" setup>
import {
  SEX_ITEMS,
  FABRIC_ITEMS,
  SEASON_ITEMS,
  SIZE_ITEMS,
  WEAR_CATEGORY_ITEMS,
  SILHOUETTE_ITEMS,
} from "~/const/product"
import type { ProductAllListProps_Filter } from "~/types/product"

const props = defineProps<{
  filter: ProductAllListProps_Filter
}>()

const filterCountNum = computed(() => {
  return Object.values(props.filter).reduce((acc, cur) => {
    if (Array.isArray(cur)) {
      return acc + cur.length
    }
    if (typeof cur === "boolean") {
      return acc + (cur ? 1 : 0)
    }
    return acc
  }, 0)
})

const displayActiveFilterColumn = () => {
  if (filterCountNum.value <= 0) return ""
  let displayFilteredText = ""

  Object.entries(props.filter).map(([key, value]) => {
    if (key === "sex" && Array.isArray(value) && value.length > 0) {
      value.map((v) => {
        const sexItem = SEX_ITEMS.find((item) => item.value === v)
        if (sexItem) displayFilteredText += `${sexItem.key} / `
        return v
      })
    }

    if (key === "fabric" && Array.isArray(value) && value.length > 0) {
      value.map((v) => {
        const fabricItem = FABRIC_ITEMS.find((item) => item.value === v)
        if (fabricItem) displayFilteredText += `${fabricItem.key} / `
        return v
      })
    }

    if (key === "season" && Array.isArray(value) && value.length > 0) {
      value.map((v) => {
        const seasonItem = SEASON_ITEMS.find((item) => item.value === v)
        if (seasonItem) displayFilteredText += `${seasonItem.key} / `
        return v
      })
    }

    if (key === "wear_category" && Array.isArray(value) && value.length > 0) {
      value.map((v) => {
        const wearCategoryItem = WEAR_CATEGORY_ITEMS.find((item) => item.value === v)
        if (wearCategoryItem) displayFilteredText += `${wearCategoryItem.key} / `
        return v
      })
    }

    if (key === "size" && Array.isArray(value) && value.length > 0) {
      value.map((v) => {
        const sizeItem = SIZE_ITEMS.find((item) => item.value === v)
        if (sizeItem) displayFilteredText += `${sizeItem.key} / `
        return v
      })
    }

    if (key === "silhouette" && Array.isArray(value) && value.length > 0) {
      value.map((v) => {
        const silhouetteItem = SILHOUETTE_ITEMS.find((item) => item.value === v)
        if (silhouetteItem) displayFilteredText += `${silhouetteItem.key} / `
        return v
      })
    }

    return value
  })

  return displayFilteredText.slice(0, -3)
}

defineEmits<{
  (e: "update:isOpenFilterSp", isOpenFilterSp: boolean): void
}>()
</script>

<style scoped module lang="scss">
.fixFilter {
  display: block;
  width: 280px;
  background: $white;
  position: fixed;
  z-index: 3;
  bottom: 3%;
  right: 5%;
  border-radius: 6px;
  font-size: $font-size-10;
  font-weight: normal;
  .fixFilterInner {
    width: 100%;
    display: flex;
    text-align: center;
    justify-content: space-between;
    padding: 13px 16px;
    border-radius: 6px;
    box-shadow: 0 0 1px 0 $light-blue;
    font-size: 12px;
  }

  .filteredActive {
    background: $secondary-20;
    overflow: hidden;
    column-gap: 1rem;
    font-weight: normal;
    .filteredActiveText {
      display: block;
      text-align: left;
      overflow: hidden;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 10px;
    }
    .filteredActiveLink {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 0.5rem;
      font-size: 12px;
      text-decoration: underline;
    }
  }

  .defaultFilterOpenButton {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
    width: 100%;
    text-align: center;
    font-size: 12px;
    text-decoration: underline;
    line-height: 1;
    padding: 1rem 0;
    box-shadow: 0 0 4px 0 #cecece;
  }
}
</style>
